import { useState } from "react";
import { useNavigate } from "react-router-dom";
import StarField from "@/components/StarField";
import TopBar from "@/components/TopBar";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

const BENEFITS = [
  "Priority access to all events",
  "Early ticket access",
  "Automatic 15% discount on entry tickets",
  "Members-only events and drops",
  "Exclusive notifications",
  "Priority checkout queue",
];

export default function Membership() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const subscribe = async () => {
    if (!user) { navigate("/register?intent=membership"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/checkout/membership", { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (err) {
      toast.error(err.response?.data?.detail || "Checkout failed");
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen">
      <StarField count={140} />
      <TopBar />
      <main className="relative z-20 flex items-center justify-center px-6 py-16">
        <div className="glass-strong rounded-sm p-10 sm:p-14 w-full max-w-2xl">
          <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-cyan-400/80 text-center mb-2">— inner circle —</div>
          <h1 className="font-display text-4xl sm:text-5xl font-black uppercase text-center neon-cyan">Membership</h1>
          <div className="text-center mt-4">
            <span className="font-display text-6xl font-black">$10</span>
            <span className="font-mono text-sm uppercase tracking-widest text-white/60"> /month</span>
          </div>

          <ul className="mt-10 space-y-3 max-w-md mx-auto">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-start gap-3 font-mono text-sm text-white/80">
                <span className="text-cyan-400 mt-1">◆</span><span>{b}</span>
              </li>
            ))}
          </ul>

          <button
            onClick={subscribe}
            disabled={loading}
            data-testid="membership-subscribe-btn"
            className="gate mt-12 w-full py-4 bg-white text-black font-display font-bold uppercase tracking-[0.3em] text-sm rounded-sm hover:scale-[1.01] transition"
          >
            {loading ? "Opening gate..." : "Become A Member"}
          </button>

          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 text-center mt-6">
            Secure checkout via Stripe. Test card 4242 4242 4242 4242.
          </p>
        </div>
      </main>
    </div>
  );
}
